<template>
  <div class='oj_subject_offline'>
    <Offline :dataAPI='offLineQuestionAPI' :parasms='parasm' :selectDefunct='"Y"'></Offline>
  </div>
</template>

<script>
import Offline from './Subject_online';
export default {
  name:'oj_subject_offlin',
  data(){
    return{
      offLineQuestionAPI:'/v1/problem/list',
      parasm:{ defunct:'Y' }
    };
  },
  components:{
    Offline
  }
};
</script>

<style scoped>
</style>